<template>
  <div class="d-flex h-100">
    <b-container class="m-auto">
      <b-row align-h="center" align-v="center">
        <h1><i :class="!isMobile ? 'fas fa-pencil-ruler c-green fa-3x' : 'fas fa-pencil-ruler c-green'"></i></h1>
      </b-row>
      <b-row align-h="center" align-v="center">
        <h5 v-if="isMobile">{{$t('message.workInProgress')}}</h5>
        <h1 v-else>{{$t('message.workInProgress')}}</h1>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'WorkInProgress',
  mounted () {
    this.checkWindowWidth()
    this.$root.$on('resize', () => {
      this.checkWindowWidth()
    })
  },
  data () {
    return {
      isMobile: false
    }
  },
  methods: {
    checkWindowWidth () {
      const size = Vue.myGetWindowSize()
      this.isMobile = (size !== 'md' && size !== 'lg' && size !== 'xl')
    }
  }
}
</script>

<style scoped>

</style>
